module.exports = __webpack_public_path__ + "static/media/pin_blue.d7c43727.svg";